import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './i-charge-news.css'

const IChargeNews = (props) => {
  return (
    <div className="i-charge-news-container1">
      <Helmet>
        <title>iChargeNews - Copy of iCharge web copy 2</title>
        <meta
          property="og:title"
          content="iChargeNews - Copy of iCharge web copy 2"
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="i-charge-news-text10">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="i-charge-news-text11">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="i-charge-news-text12">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="i-charge-news-text13">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="i-charge-news-text14">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="i-charge-news-text15">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="i-charge-news-text16">Cultivating Connection</span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="i-charge-news-text17">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="i-charge-news-text21">How to charge</span>
          </Fragment>
        }
        chargingPointLink1={
          <Fragment>
            <span className="i-charge-news-text22">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="i-charge-news-text23">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <main className="column align-center full-width">
        <section className="i-charge-news-hero column align-center justify-center full-width thq-section-padding">
          <div className="i-charge-news-container2">
            <img
              alt="pastedImage"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/external/width_639-1500w.webp"
              srcSet="/external//width_639-1500w.webp 1200w, /external/width_639-tablet.webp 800w, /external/width_639-mobile.webp 480w"
              className="i-charge-news-pasted-image"
            />
          </div>
          <div className="i-charge-news-max-width1 row full-width max-content-width">
            <div className="i-charge-news-right column gap-2-5">
              <div className="i-charge-news-container3">
                <h1 className="i-charge-news-text24 heading-1">iCharge News</h1>
              </div>
              <div className="i-charge-news-container4">
                <p className="i-charge-news-text25 sub-heading-1">
                  iCharge at Automotive Fair Albania 2025
                </p>
                <div className="i-charge-news-container5">
                  <span className="i-charge-news-text26 sub-heading-2">
                    Participation in Automotive Fair Albania 2025 was a valuable
                    opportunity to connect with the community of professionals
                    and businesses shaping the vehicle sector in Albania.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="i-charge-news-who-benefits column align-center justify-center full-width thq-section-padding">
          <div className="i-charge-news-max-width2 column align-center full-width max-content-width">
            <div className="row full-width i-charge-news-cards-container">
              <div className="i-charge-news-container6 column align-center gap-6 flex-1">
                <img
                  alt="image"
                  sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                  src="/external/width_600-1500w.webp"
                  srcSet="/external//width_600-1500w.webp 1200w, /external/width_600-tablet.webp 800w, /external/width_600-mobile.webp 480w"
                  className="i-charge-news-image"
                />
              </div>
              <div className="i-charge-news-container7 column align-center gap-6 flex-1">
                <div className="i-charge-news-container8">
                  <span className="i-charge-news-text27 sub-heading-1">
                    During the fair
                  </span>
                  <ul className="i-charge-news-ul list">
                    <li className="i-charge-news-li1 list-item">
                      <span className="i-charge-news-text28 sub-heading-2">
                        Presented the iCharge platform for station management
                      </span>
                    </li>
                    <li className="i-charge-news-li2 list-item">
                      <span className="i-charge-news-text29 sub-heading-2">
                        Demonstrated technical solutions for functional,
                        accessible, and sustainable service
                      </span>
                    </li>
                    <li className="i-charge-news-li3 list-item">
                      <span className="i-charge-news-text30 sub-heading-2">
                        Visitors experienced the network, app, and business
                        collaboration possibilities firsthand
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer rootClassName="footerroot-class-name13"></Footer>
    </div>
  )
}

export default IChargeNews
